export const MODIFY_EDIT_ID = 'MODIFY_EDIT_ID';

export function modifyEditID(editID){
    return{
        type: MODIFY_EDIT_ID,
        mainState: {
            editID: editID
        }
    }
}